// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__KNRXe","disable":"Item_disable__2k8OC","quantity":"Item_quantity__2uY_m","plus":"Item_plus__1sHWc","minus":"Item_minus__2p-EQ"};